import { memo, Fragment } from "react";
import PropTypes from "prop-types";
import { createMarkup } from "../../../utils/helperServices";
import config from "../../../config/index";
import styles from "./DeliveryTitle.module.scss";

const DeliveryTitle = memo(
  ({ title, contents, className, id, iconType, descClassName }) => {
    const env = config.env;
    const imagePrefix = config.envConfigs[env].imagePrefix;

    const checkIcon = (icon) => {
      switch(icon) {
        case "tick":
          return "tick.svg";
        case "info-white":
          return "info_white.svg";
        case "error-circle":
          return "error-circle.svg";
        case "error-circle-white":
          return "error-circle-white.svg";
        default:
          return "error-circle-white.svg";
      }
    }

    const iconTypeSvg = checkIcon(iconType);
      
    const iconTypePath = `${imagePrefix}/assets/images/${iconTypeSvg}`;

    const ListItem = ({ index, icon, desc }) => {
      return (
        <>
          {iconType == "dot" ? (
            <li
              id={`${id}-item-${index}`}
              className={styles["desc"]}
              dangerouslySetInnerHTML={createMarkup(desc)}
            ></li>
          ) : (
            <div className={styles["item"]} key={index}>
              <img className={styles["icon"]} src={icon} />
              <span
                id={`${id}-item-${index}`}
                className={`${styles["desc"]} ${descClassName}`}
                dangerouslySetInnerHTML={createMarkup(desc)}
              ></span>
            </div>
          )}
        </>
      );
    };

    const listItems = contents.map((item, index) =>
      item ? (
        <Fragment key={index}>
          <ListItem
            index={index}
            icon={item.icon ? item.icon : iconTypePath}
            desc={item.description ? item.description : item}
          />
        </Fragment>
      ) : null
    );

    const ContentInformation = () => {
      if (iconType == "dot") {
        return (
          contents.some(txt => txt) && 
          <ul className={`${styles["deliveryTitle__content"]} ${styles["content-ul"]}`}>
            {listItems}
          </ul>
        );
      } else {
        return (
          <div className={`${styles["deliveryTitle__content"]}`}>
            {listItems}
          </div>
        );
      }
    };

    return (
      <div className={`${styles["deliveryTitle"]} ${className}`} id={id}>
        {title && <div className={styles["deliveryTitle__title"]}>{title}</div>}
        <ContentInformation />
      </div>
    );
  }
);

DeliveryTitle.defaultProps = {
  title: null,
  contents: [],
  iconType: "tick",
};

DeliveryTitle.propTypes = {
  title: PropTypes.string,
  contents: PropTypes.array,
  className: PropTypes.string,
  id: PropTypes.string,
  iconType: PropTypes.string,
};

export default DeliveryTitle;
